<abp-page [title]="'Inventory::AssetEvents' | abpLocalization">
  <abp-page-toolbar-container class="col">
    <div class="text-lg-end pt-2">
      <button
        *abpPermission="'Inventory.AssetEvents.Create'"
        class="btn btn-primary btn-sm"
        type="button"
        (click)="create()"
      >
        <i class="fa fa-plus me-1" aria-hidden="true"></i>
        {{ 'Inventory::NewAssetEvent' | abpLocalization }}
      </button>
    </div>
  </abp-page-toolbar-container>

  <abp-advanced-entity-filters localizationSourceName="Inventory" [list]="list">
    <abp-advanced-entity-filters-form>
      <form #filterForm (keyup.enter)="list.get()">
        <div class="row">
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="descriptionFilter">
                {{ 'Inventory::Description' | abpLocalization }}
              </label>

              <input
                id="descriptionFilter"
                class="form-control"
                [(ngModel)]="filters.description"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="minEventDateTime">
                  {{ 'Inventory::MinEventDateTime' | abpLocalization }}
              </label>

              <div class="input-group" validationTarget>
                <input
                  id="minEventDateTime"
                  class="form-control"
                  #minEventDateTimeInput
                  #minEventDateTimeDatepicker="ngbDatepicker"
                  name="minEventDateTime"
                  ngbDatepicker
                  container="body"
                  readonly
                  (click)="minEventDateTimeDatepicker.toggle()"
                  (keyup.space)="minEventDateTimeDatepicker.toggle()"
                  [(ngModel)]="filters.eventDateTimeMin"
                  [ngModelOptions]="{ standalone: true }"
                />
                <div *ngIf="minEventDateTimeInput.value" class="input-group-append">
                  <button
                    class="btn btn-link px-2"
                    type="button"
                    [title]="'AbpUi::Clear' | abpLocalization"
                    (click)="minEventDateTimeDatepicker.writeValue(null); minEventDateTimeDatepicker.manualDateChange(null, true)"
                  >
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="maxEventDateTime">
                {{ 'Inventory::MaxEventDateTime' | abpLocalization }}
              </label>

              <div class="input-group" validationTarget>
                <input
                  id="maxEventDateTime"
                  class="form-control"
                  #maxEventDateTimeInput
                  #maxEventDateTimeDatepicker="ngbDatepicker"
                  name="maxEventDateTime"
                  ngbDatepicker
                  readonly
                  (click)="maxEventDateTimeDatepicker.toggle()"
                  (keyup.space)="maxEventDateTimeDatepicker.toggle()"
                  [(ngModel)]="filters.eventDateTimeMax"
                  [ngModelOptions]="{ standalone: true }"
                />
                <div *ngIf="maxEventDateTimeInput.value" class="input-group-append">
                  <button
                    class="btn btn-link px-2"
                    type="button"
                    [title]="'AbpUi::Clear' | abpLocalization"
                    (click)="maxEventDateTimeDatepicker.writeValue(null); maxEventDateTimeDatepicker.manualDateChange(null, true)"
                  >
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="assetIdFilter">
                {{ 'Inventory::Asset' | abpLocalization }}
              </label>
              <abp-lookup-input
                cid="assetIdFilter"
                displayNameProp="name"
                lookupNameProp="displayName"
                [getFn]="service.getAssetLookup"
                [(ngModel)]="filters.assetId"
                [ngModelOptions]="{ standalone: true }"
              ></abp-lookup-input>
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="eventTypeIdFilter">
                {{ 'Inventory::EventType' | abpLocalization }}
              </label>
              <abp-lookup-input
                cid="eventTypeIdFilter"
                displayNameProp="name"
                lookupNameProp="displayName"
                [getFn]="service.getEventTypeLookup"
                [(ngModel)]="filters.eventTypeId"
                [ngModelOptions]="{ standalone: true }"
              ></abp-lookup-input>
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="noteIdFilter">
                {{ 'Inventory::Note' | abpLocalization }}
              </label>
              <abp-lookup-input
                cid="noteIdFilter"
                displayNameProp="title"
                lookupNameProp="displayName"
                [getFn]="service.getNoteLookup"
                [(ngModel)]="filters.noteId"
                [ngModelOptions]="{ standalone: true }"
              ></abp-lookup-input>
            </div>
          </div>

          <div class="col-12 col-sm-auto align-self-end mb-3">
            <div class="row">
              <div class="col-6 col-sm-auto d-grid">
                <button
                  type="button"
                  class="btn btn-outline-primary"
                  (click)="clearFilters()"
                >
                  <span>{{ 'AbpUi::Clear' | abpLocalization }}</span>
                </button>
              </div>
              <div class="col-6 col-sm-auto d-grid">
                <button type="button" class="btn btn-primary" (click)="list.get()">
                  <span>{{ 'AbpUi::Refresh' | abpLocalization }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </abp-advanced-entity-filters-form>
  </abp-advanced-entity-filters>

  <div class="card">
    <div class="card-body">
      <ngx-datatable [rows]="data.items" [count]="data.totalCount" [list]="list" default>
        <ngx-datatable-column
          [name]="'AbpUi::Actions' | abpLocalization"
          [maxWidth]="150"
          [width]="150"
          [sortable]="false"
        >
          <ng-template let-row="row" let-i="rowIndex" ngx-datatable-cell-template>
            <div ngbDropdown container="body" class="d-inline-block">
              <button
                class="btn btn-primary btn-sm dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                ngbDropdownToggle
              >
                <i class="fa fa-cog me-1" aria-hidden="true"></i>
                {{ 'AbpUi::Actions' | abpLocalization }}
              </button>

              <div ngbDropdownMenu>
                <button
                  ngbDropdownItem
                  *abpPermission="'Inventory.AssetEvents.Edit'"
                  (click)="update(row)"
                >
                  {{ 'AbpUi::Edit' | abpLocalization }}
                </button>

                <button
                  ngbDropdownItem
                  *abpPermission="'Inventory.AssetEvents.Delete'"
                  (click)="delete(row)"
                >
                  {{ 'AbpUi::Delete' | abpLocalization }}
                </button>
              </div>
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::Description' | abpLocalization }}" prop="assetEvent.description">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.assetEvent.description }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::EventDateTime' | abpLocalization }}" prop="assetEvent.eventDateTime">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.assetEvent.eventDateTime | date }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::Asset' | abpLocalization }}" prop="asset.name">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.asset?.name }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::EventType' | abpLocalization }}" prop="eventType.name">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.eventType?.name }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::Note' | abpLocalization }}" prop="note.title">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.note?.title }}
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>
  </div>
</abp-page>

<abp-modal [busy]="isModalBusy" [(visible)]="isModalOpen">
  <ng-template #abpHeader>
    <h3>
      {{ (selected ? 'AbpUi::Edit' : 'Inventory::NewAssetEvent') | abpLocalization }}
    </h3>
  </ng-template>

  <ng-template #abpBody>
    <form [formGroup]="form" (ngSubmit)="submitForm()" validateOnSubmit>
      <div class="mt-2 fade-in-top">
        <div class="mb-3">
          <label class="form-label" for="asset-event-description">
            {{ 'Inventory::Description' | abpLocalization }} *
          </label>

          <input
            id="asset-event-description"
            formControlName="description"
            class="form-control"
            autofocus
          />
        </div>
        <div class="mb-3">
          <label class="form-label" for="asset-event-event-date-time">
            {{ 'Inventory::EventDateTime' | abpLocalization }} *
          </label>

          <div class="input-group" validationTarget>
            <input
              readonly
              id="asset-event-event-date-time"
              formControlName="eventDateTime"
              class="form-control"
              ngbDatepicker
              #eventDateTimeInput
              #eventDateTimeDatepicker="ngbDatepicker"
              (click)="eventDateTimeDatepicker.open()"
              (keyup.space)="eventDateTimeDatepicker.open()"
            />
            <div *ngIf="eventDateTimeInput.value" class="input-group-append">
              <button
                class="btn btn-link px-2"
                type="button"
                [title]="'AbpUi::Clear' | abpLocalization"
                (click)="eventDateTimeDatepicker.writeValue(null); eventDateTimeDatepicker.manualDateChange(null, true)"
              >
                <i class="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label" for="asset-event-asset-id">
            {{ 'Inventory::Asset' | abpLocalization }} *
          </label>
          <abp-lookup-input
            cid="asset-event-asset-id"
            formControlName="assetId"
            displayNameProp="name"
            lookupNameProp="displayName"
            [getFn]="service.getAssetLookup"
            [editingData]="selected?.asset"
          ></abp-lookup-input>
        </div>
        <div class="mb-3">
          <label class="form-label" for="asset-event-event-type-id">
            {{ 'Inventory::EventType' | abpLocalization }} *
          </label>
          <abp-lookup-input
            cid="asset-event-event-type-id"
            formControlName="eventTypeId"
            displayNameProp="name"
            lookupNameProp="displayName"
            [getFn]="service.getEventTypeLookup"
            [editingData]="selected?.eventType"
          ></abp-lookup-input>
        </div>
        <div class="mb-3">
          <label class="form-label" for="asset-event-note-id">
            {{ 'Inventory::Note' | abpLocalization }} 
          </label>
          <abp-lookup-input
            cid="asset-event-note-id"
            formControlName="noteId"
            displayNameProp="title"
            lookupNameProp="displayName"
            [getFn]="service.getNoteLookup"
            [editingData]="selected?.note"
          ></abp-lookup-input>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template #abpFooter>
    <button type="button" class="btn btn-secondary" abpClose>
      {{ 'AbpUi::Cancel' | abpLocalization }}
    </button>

    <abp-button iconClass="fa fa-check" (click)="submitForm()" [disabled]="form?.invalid">
      {{ 'AbpUi::Save' | abpLocalization }}
    </abp-button>
  </ng-template>
</abp-modal>
